!(function () {
  const BREAKPOINT_MOBILE = 576; // < 576 px => Slider AN

  const addSwiperClasses = (el) => {
    const wrapper = el.querySelector(".m1-bike-cards__grid-inner");
    const slides  = el.querySelectorAll(".m1-bike-card");
    el.classList.add("swiper");
    wrapper && wrapper.classList.add("swiper-wrapper");
    slides.forEach((s) => s.classList.add("swiper-slide"));
  };

  const removeSwiperClasses = (el) => {
    const wrapper = el.querySelector(".m1-bike-cards__grid-inner");
    const slides  = el.querySelectorAll(".m1-bike-card");
    el.classList.remove("swiper");
    wrapper && wrapper.classList.remove("swiper-wrapper");
    slides.forEach((s) => {
      s.removeAttribute("style");
      s.classList.remove("swiper-slide");
    });
  };

  const initSwiper = (section) => {
    const el = section.querySelector(".m1-bike-cards__grid");
    if (!el || el.classList.contains("swiper-initialized")) return;

    addSwiperClasses(el);

    const mobile = Number(el.dataset.mobileColumns) || 1;
    const prevBtn = section.querySelector(".m1-bike-cards__nav--prev");
    const nextBtn = section.querySelector(".m1-bike-cards__nav--next");
    const pagEl   = section.querySelector(".m1-bike-cards__pagination");

    const config = {
      loop: false,
      speed: 700,
      slidesPerView: mobile,
      slidesPerGroup: mobile,
      freeMode: true,
      direction: "horizontal",
      spaceBetween: 16,
      touchStartPreventDefault: false,
      touchMoveStopPropagation: false,
      touchAngle: 20,
      pagination: pagEl ? { el: pagEl, clickable: true, type: "bullets" } : undefined,
      navigation: (prevBtn && nextBtn) ? { prevEl: prevBtn, nextEl: nextBtn } : undefined,
      keyboard: { enabled: true, onlyInViewport: true }
    };

    const swiper = new Swiper(el, config);

    const updateNav = () => {
      if (!(prevBtn && nextBtn)) return;
      const locked =
        swiper.isLocked ||
        (swiper.slides && swiper.slides.length <= swiper.params.slidesPerView);
      prevBtn.style.display = locked ? "none" : "grid";
      nextBtn.style.display = locked ? "none" : "grid";
      const atStart = swiper.progress <= 0.001;
      const atEnd   = swiper.progress >= 0.999;
      prevBtn.disabled = locked || atStart;
      nextBtn.disabled = locked || atEnd;
      prevBtn.setAttribute("aria-disabled", String(prevBtn.disabled));
      nextBtn.setAttribute("aria-disabled", String(nextBtn.disabled));
    };

    swiper.on("afterInit", updateNav);
    swiper.on("slideChange", updateNav);
    swiper.on("resize", updateNav);
    swiper.on("lock", updateNav);
    swiper.on("unlock", updateNav);
    swiper.on("progress", updateNav);
    updateNav();
  };

  const destroySwiper = (section) => {
    const el = section.querySelector(".m1-bike-cards__grid");
    if (el && el.swiper) {
      el.swiper.destroy(true, true);
      removeSwiperClasses(el);
    }
  };

  const observeSection = (section) => {
    if (!section || !section.classList.contains("m1-bike-cards-section")) return;

    const ro = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const width = entry.contentRect.width;
        if (width < BREAKPOINT_MOBILE) initSwiper(section);
        else destroySwiper(section);
      });
    });

    ro.observe(section);
  };

  // Initial für diese Section
  observeSection(document.currentScript.parentElement);

  // Shopify Theme-Editor Reload
  document.addEventListener("shopify:section:load", (e) => observeSection(e.target));
})();
